import { aggregateBaggageSelectionCount } from 'checkout/lib/utils/flights/extras'

export function formatPaxBaggageMap(
  map: App.Checkout.PaxBaggageMap = {},
  options: Array<App.JourneyAddon>,
): string {
  const descriptionMap = options
    .reduce<{ [baggageId: string]: string }>((acc, option) => ({ ...acc, [option.id]: option.description }), {})
  const quantityMap = aggregateBaggageSelectionCount(map)

  return Object.entries<number>(quantityMap)
    .map(([id, quantity]) => {
      const description = descriptionMap[id]
      if (quantity === 0) { return }
      if (!description) { return `${quantity}x ${id}` }

      return `${quantity}x ${description}`
    })
    .filter((option) => Boolean(option))
    .join(', ')
}

export function formatPaxIncludedBaggage(
  map: App.Checkout.PaxBaggageMap = {},
  options: Array<App.JourneyAddon>,
): App.InclusionFeatures {
  const descriptionMap = options
    .reduce<{ [baggageId: string]: string }>((acc, option) => ({ ...acc, [option.id]: option.description }), {})
  const quantityMap = aggregateBaggageSelectionCount(map)

  return Object.entries<number>(quantityMap)
    .map(([id, quantity]) => {
      const description = descriptionMap[id]
      if (!description) {
        return {
          description: `${quantity}x ${id}`,
          type: 'checked_baggage',
        }
      }
      return {
        description: `${quantity}x ${description}`,
        type: 'checked_baggage',
      }
    })
}

export function formatAddedBaggage(addedBaggage: Record<string, number>): Array<App.InclusionFeature> {
  return Object.entries(addedBaggage).map(([description, quantity]) => {
    return {
      description: `${quantity}x ${description}`,
      type: 'checked_baggage',
    }
  })
}
